import React from "react";
import { useTranslation } from "react-i18next";
import { VehicleModelCard } from "./VehicleModelCard";
import { VehicleModel } from "@/types";

interface VehicleModelListProps {
  vehicleModels: VehicleModel[];
  isLoading: boolean;
  onEdit?: (vehicleModel: VehicleModel) => void;
  onDelete?: (vehicleModel: VehicleModel) => void;
  onView?: (vehicleModel: VehicleModel) => void;
  emptyMessage?: string;
}

export const VehicleModelList: React.FC<VehicleModelListProps> = ({
  vehicleModels,
  isLoading,
  onEdit,
  onDelete,
  onView,
  emptyMessage = "",
}) => {
  const { t } = useTranslation(["pages", "common"]);
  if (isLoading) {
    return (
 <div className="space-y-4">
        {[...Array(3)].map((_, index) => (
          <div
            key={index}
 className="bg-white rounded-lg border border-secondary-200 p-6 animate-pulse"
          >
 <div className="flex justify-between items-start mb-4">
 <div className="flex-1">
 <div className="h-6 bg-secondary-200 rounded w-3/4 mb-2"></div>
 <div className="flex items-center gap-4 mb-2">
 <div className="h-4 bg-secondary-200 rounded w-20"></div>
 <div className="h-4 bg-secondary-200 rounded w-16"></div>
                </div>
 <div className="h-4 bg-secondary-200 rounded w-24"></div>
              </div>
            </div>
 <div className="mb-4">
 <div className="h-4 bg-secondary-200 rounded w-full mb-2"></div>
 <div className="h-4 bg-secondary-200 rounded w-3/4"></div>
            </div>
 <div className="flex justify-between items-center">
 <div className="h-4 bg-secondary-200 rounded w-32"></div>
 <div className="flex gap-2">
 <div className="h-8 w-8 bg-secondary-200 rounded"></div>
 <div className="h-8 w-8 bg-secondary-200 rounded"></div>
 <div className="h-8 w-8 bg-secondary-200 rounded"></div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (vehicleModels.length === 0) {
    return (
 <div className="text-center py-12">
 <div className="max-w-md mx-auto">
 <div className="bg-secondary-50 rounded-full p-4 w-16 h-16 mx-auto mb-4 flex items-center justify-center">
            <svg
 className="w-8 h-8 text-secondary-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
              />
            </svg>
          </div>
  <h3 className="text-lg font-medium text-secondary-900 mb-2">
            {t("pages:vehicles.models.listEmptyTitle")}
          </h3>
  <p className="text-secondary-600">
            {emptyMessage || t("pages:vehicles.models.defaultEmptyMessage")}
          </p>
        </div>
      </div>
    );
  }

  return (
 <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {vehicleModels.map((vehicleModel) => (
        <VehicleModelCard
          key={vehicleModel.id}
          vehicleModel={vehicleModel}
          onEdit={onEdit}
          onDelete={onDelete}
          onView={onView}
        />
      ))}
    </div>
  );
};
